import { AssessmentComponent } from "@pandas/assessment-engine";
import { FlowType } from "./flowTypeHelpers";

export const Screens = [
	"assessments",
	"splash-screen",
	"stored-assessment-results",
	"start",
	"what-you-need",
	"add-assessments",
	"imei",
	"device-identified",
	"assessment-results",
	"user-info",
	"offer",
	"trade-in-completion",
	"reveal-imei",
	"redirection",
	"store-locations",
	"trade-in-completion-from-home",
	"trade-in-completion-on-vision",
] as const;

export type Screen = (typeof Screens)[number];

export const assessmentScreens = [
	"digitizer",
	"audio",
	"multitouch",
	"biometrics",
	"gyroscope",
	"front-camera-ai",
	"back-camera-ai",
	"self-front-cosmetics",
	"self-back-cosmetics",
	"self-body-frame-cosmetics",
	"self-camera-cosmetics",
	"self-lcd-condition",
	"self-buttons-work",
	"grader-front-cosmetics",
	"grader-back-cosmetics",
	"grader-body-frame-cosmetics",
	"grader-camera-cosmetics",
	"grader-lcd-condition",
	"grader-device-skin",
	"question-body-frame",
	"question-screen-blemishes",
	"self-device-turns-on",
	"self-device-skin",
	"self-charger",
	"self-device-material",
	"self-overall-condition",
	"self-strap",
] as const;

export type AllScreens = Screen | AssessmentComponent;

export const defaultFlow: Array<AllScreens> = [
	"splash-screen",
	"stored-assessment-results",
	"start",
	"what-you-need",
	"assessments",
	"add-assessments",
	"imei",
	"device-identified",
	"assessment-results",
	"stored-assessment-results",
	"offer",
	"store-locations",
];

const flexOrVisionFlow: Array<AllScreens> = [
	"splash-screen",
	"stored-assessment-results",
	"what-you-need",
	"assessments",
	"add-assessments",
	"stored-assessment-results",
];

const functionalFirstFlow: Array<AllScreens> = [...flexOrVisionFlow, "user-info", "reveal-imei"];

const cosmeticFirstFlow: Array<AllScreens> = [...flexOrVisionFlow, "offer", "user-info"];

const cosmeticFirstFlowFromStore: Array<AllScreens> = [...cosmeticFirstFlow, "trade-in-completion"];

const cosmeticFirstFromHomeFlow: Array<AllScreens> = [...cosmeticFirstFlow, "trade-in-completion-from-home"];

const retailAppFlow: Array<AllScreens> = [
	"splash-screen",
	"stored-assessment-results",
	"what-you-need",
	"assessments",
	"add-assessments",
	"imei",
	"stored-assessment-results",
	"offer",
	"user-info",
	"trade-in-completion",
];

export const flowScreens: Record<FlowType, Array<AllScreens>> = {
	default: defaultFlow,
	"functional-first-from-store": functionalFirstFlow,
	"cosmetic-first-from-store": cosmeticFirstFlowFromStore,
	"cosmetic-first-from-home": cosmeticFirstFromHomeFlow,
	"retail-app": retailAppFlow,
};
